import { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";
import HeadingOneIcon from "../../../../assets/icon/CampaignNotesToolbar/HeadingOneIcon";
import HeadingThreeIcon from "../../../../assets/icon/CampaignNotesToolbar/HeadingThreeIcon";
import HeadingTwoIcon from "../../../../assets/icon/CampaignNotesToolbar/HeadingTwoIcon";
import EditToolbarButton from "./EditToolbarButton";
import { handleH1, handleH2, handleH3, handleParagraph } from "./toolbarUtils";

interface HeadingButtonProps {
  editor: Editor;
}
export default function HeadingButton({ editor }: HeadingButtonProps) {
  const [headingLevel, setHeadingLevel] = useState(0);

  useEffect(() => {
    if (editor) {
      switch (headingLevel) {
        case 1:
          handleH1(editor);
          break;
        case 2:
          handleH2(editor);
          break;
        case 3:
          handleH3(editor);
          break;
        default:
          handleParagraph(editor);
      }
    }
  }, [headingLevel, editor]);

  const handleClick = () => {
    setHeadingLevel((prevLevel) => (prevLevel === 3 ? 0 : prevLevel + 1));
  };

  return (
    <EditToolbarButton
      onClick={handleClick}
      editor={editor}
      tooltipId="heading"
      tooltipText="Heading"
      isActive={editor.isActive("heading")}
    >
      {(headingLevel === 0 || headingLevel === 1) && <HeadingOneIcon />}
      {headingLevel === 2 && <HeadingTwoIcon />}
      {headingLevel === 3 && <HeadingThreeIcon />}
    </EditToolbarButton>
  );
}
